import $ from 'jquery';
import { onModuleLoad, onModuleUnload } from 'runtime';
import { displayValidationSummary, hideValidationSummary } from 'ui-utils';
import { parseErrors } from 'utils';

onModuleLoad(import.meta, () => {
    window.initExpressCheckout = async container => {
        const buyNow = container.closest('#buy-now');

        if (!buyNow)
            return;

        const form = buyNow.closest('form');

        if (!$(form).valid())
            return false;

        const { response, data } = await form.$data.submit({ createSessionId: true });

        if (!response.ok) {
            const errors = parseErrors(data, form.$data.defaultErrorMessage);
            displayValidationSummary(form, errors);
            return false;
        }

        hideValidationSummary(form);
        buyNow.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: data }));
    }
});

onModuleUnload(import.meta, () =>delete window.initExpressCheckout);
